export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en-US": {
        "filter_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter by"])},
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Products loading"])},
        "reset_all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Reset all"])},
        "shown_products": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["No products shown"]), _normalize(["1 Product shown"]), _normalize([_interpolate(_named("count")), " Products shown"])])}
      },
      "de-DE": {
        "filter_by": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Filter nach"])},
        "loading": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Produkte werden geladen"])},
        "reset_all": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle zurücksetzen"])},
        "shown_products": (ctx) => {const { normalize: _normalize, interpolate: _interpolate, named: _named, plural: _plural } = ctx;return _plural([_normalize(["Kein angezeigtes Produkt"]), _normalize(["1 angezeigtes Produkt"]), _normalize([_interpolate(_named("count")), " angezeigte Produkte"])])}
      }
    }
  })
}
